import React from "react"
import { WorkOrderScreenViewModel } from "./WorkOrderScreenViewModel"
import { AssetPart } from "@model/assets/AssetPart"
import { Modal, ModalBody, ModalButtons, ModalContent, ModalHeader, ModalHeaderTitle } from "@ui/common/Modal"
import { Grid, GridGap } from "@ui/common/grids/Grid"
import { Button, ButtonType } from "@ui/common/buttons/Button"


export function PartsListModal({
    isLoading,
    isVisible,
    parts,
    onClose,
}: {
    isLoading: boolean
    isVisible: boolean
    parts: AssetPart[] | undefined
    onClose: () => void
}): JSX.Element {
    return (
        <Modal useContentTag={true} isVisible={isVisible} onClose={onClose}>
            <ModalContent isLoading={isLoading}>
                <ModalHeader>
                    <ModalHeaderTitle>Parts List</ModalHeaderTitle>
                </ModalHeader>
                <ModalBody>
                    <Grid columns={1} gap={GridGap.Small}>
                        <ul className="parts-list-ul">
                            {parts?.map((el, i) => (
                                <li>{el.description + " (" + el.partNumber + ")"}</li>
                            ))}
                        </ul>
                    </Grid>
                </ModalBody>
                <ModalButtons>
                    <Button
                        label={"Close"}
                        type={ButtonType.Text}
                        onClick={onClose}
                    />
                </ModalButtons>
            </ModalContent>
        </Modal>
    )
}